(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.countdownInitialized) return;
      root.dataset.countdownInitialized = 'true';
      const deadline = new Date(root.dataset.deadline).getTime();
      if (Number.isNaN(deadline)) return;
      const grid = root.querySelector('.countdown__grid');
      const complete = root.querySelector('.countdown__complete');
      const fields = {
        days: root.querySelector('[data-countdown-days]'),
        hours: root.querySelector('[data-countdown-hours]'),
        minutes: root.querySelector('[data-countdown-minutes]'),
        seconds: root.querySelector('[data-countdown-seconds]'),
      };
      const pad = (n) => String(n).padStart(2, '0');
      let timer;
      const tick = () => {
        const diff = deadline - Date.now();
        if (diff <= 0) {
          if (timer) clearInterval(timer);
          const text = root.dataset.completeText;
          if (text) {
            grid.hidden = true;
            complete.textContent = text;
            complete.hidden = false;
          } else {
            Object.values(fields).forEach((el) => { if (el) el.textContent = '00'; });
          }
          return;
        }
        const s = Math.floor(diff / 1000);
        if (fields.days) fields.days.textContent = pad(Math.floor(s / 86400));
        if (fields.hours) fields.hours.textContent = pad(Math.floor((s % 86400) / 3600));
        if (fields.minutes) fields.minutes.textContent = pad(Math.floor((s % 3600) / 60));
        if (fields.seconds) fields.seconds.textContent = pad(s % 60);
      };
      tick();
      timer = setInterval(tick, 1000);
    };
    const initAll = () => document.querySelectorAll('[data-countdown-root]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["restock-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    const read = (key) => {
      try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (e) { return {}; }
    };
    const write = (key, val) => {
      try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
    };
    const init = (root) => {
      if (root.dataset.restockInit) return;
      root.dataset.restockInit = '1';
      const handle = root.dataset.handle;
      const likeBtn = root.querySelector('[data-restock-like]');
      if (!likeBtn) return;

      const paint = () => {
        const liked = read('wbLikes')[handle];
        likeBtn.classList.toggle('is-liked', !!liked);
        likeBtn.innerHTML = liked ? '&#9829;' : '&#9825;';
      };
      paint();

      likeBtn.addEventListener('click', () => {
        const likes = read('wbLikes');
        if (likes[handle]) { delete likes[handle]; } else { likes[handle] = 1; }
        write('wbLikes', likes);
        paint();
        const rect = likeBtn.getBoundingClientRect();
        if (likes[handle] && window.whimsieSpawnBurst) {
          window.whimsieSpawnBurst(rect.left + rect.width / 2, rect.top + rect.height / 2, 8);
        }
      });
    };
    const initAll = () => document.querySelectorAll('[data-restock-root]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
